function stylesheet(useActualHostSelector, token) {
  var shadowSelector = token ? ("[" + token + "]") : "";
  var hostSelector = token ? ("[" + token + "-host]") : "";
  return (useActualHostSelector ? "[dir=\"rtl\"] :host {direction: ltr;unicode-bidi: embed;}" : ["[dir=\"rtl\"] ", hostSelector, " {direction: ltr;unicode-bidi: embed;}"].join(''));
}
export default [stylesheet];